import { useState } from 'react'

import {
  deleteMockIntegrationConnection,
  postMockIntegrationConnect,
} from '../../../../RentalPortalListing'
import {
  INTEGRATIONS_FORM_FIELD,
  IntegrationsAction,
} from '../../RentalPortalIntegrations.constants'
import {
  getHasIntegrationConnection,
  getIntegrationConnectionStatus,
  getIsIntegrationConnected,
  getIsIntegrationCredentialConnect,
} from '../../RentalPortalIntegrations.utils'

export function useIntegrationsConnectionActions({ connection, onChanged }) {
  const [action, setAction] = useState(null)
  const [isSaving, setSaving] = useState(false)

  const status = getIntegrationConnectionStatus(connection)

  const isConnected = getIsIntegrationConnected(status)

  const hasConnection = getHasIntegrationConnection(status)

  function handleCloseAction() {
    setAction(null)
  }

  function handleStartConnect() {
    setAction(IntegrationsAction.connect)
  }

  function handleStartDisconnect() {
    setAction(IntegrationsAction.disconnect)
  }

  async function finishAction(request) {
    setSaving(true)

    return request
      .then(() => {
        setAction(null)

        onChanged()
      })
      .finally(() => setSaving(false))
  }

  async function handleConfirmConnect(values) {
    return finishAction(
      postMockIntegrationConnect({
        accountLabel: values?.[INTEGRATIONS_FORM_FIELD.username],
        portal: connection.portal,
      })
    )
  }

  async function handleConfirmDisconnect() {
    return finishAction(deleteMockIntegrationConnection(connection.portal))
  }

  return {
    action,
    handleCloseAction,
    handleConfirmConnect,
    handleConfirmDisconnect,
    handleStartConnect,
    handleStartDisconnect,
    hasConnection,
    isConnected,
    isCredentialConnect: getIsIntegrationCredentialConnect(connection),
    isSaving,
  }
}
